import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {
	constructor(
		private fb: FormBuilder,
		@Inject(MAT_DIALOG_DATA)
		private confirmationDialogData: {
			action: string;
			theSubject: string;
			additionalInformation: string;
			hideUltimatum: boolean;
		},
		private dialogRef: MatDialogRef<ConfirmationDialogComponent>
	) {}

	action: string = this.confirmationDialogData.action;
	theSubject = this.confirmationDialogData.theSubject;
	additionalInformation = this.confirmationDialogData.additionalInformation;
	hideUltimatum = this.confirmationDialogData.hideUltimatum;

	ngOnInit() {}

	yes(): void {
		this.dialogRef.close('yes');
	}

	no(): void {
		this.dialogRef.close('no');
	}
}
